export const stringsKey = "VariablesListDataGrid";
export const englishStrings = {
	tableTitle: "Variables for",
	variableName: "Name",
	variableValue: "Value",
	variableGroup: "Group",
	action: "Action",
	editBtnTooltip: "Edit Variable",
	deleteBtnTooltip: "Delete Variable",
	addVariableTooltip: "Add Variable",
};
